import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext.jsx';
import App from './app.jsx';
import './index.css';
import { applyStoredSettings } from './services/applySettings.js';

applyStoredSettings();

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter
      // Opt in to v7 behaviour now so we don't see future-flag warnings
      // in the console. These flags are no-ops once v7 is released.
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
);